import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

export const ShipmentCardSkeleton = ({ renderCheckbox }) => (
  <Card>
    <Box display="flex" flexWrap="nowrap" alignItems="center">
      {renderCheckbox && (
        <CardContent>
          <Checkbox edge="start" tabIndex={-1} disableRipple />
        </CardContent>
      )}
      <Box flexGrow={1}>
        <Box p={2}>
          <SkeletonBody lines={3} />
        </Box>
      </Box>
    </Box>
  </Card>
);

ShipmentCardSkeleton.propTypes = {
  renderCheckbox: PropTypes.bool,
};

ShipmentCardSkeleton.defaultProps = {
  renderCheckbox: false,
};

export default ShipmentCardSkeleton;
